import { useHookstate } from '@hookstate/core';
import { Dropdown } from 'primereact/dropdown';
import React, { useContext } from 'react';
import { useHistory } from "react-router-dom";
import { globalBlockedState } from '../app-context';
import { MyStructuresContext, StructureContext } from '../structure-context';

export const StructureSwitcher = (parentProps) => {
    const history = useHistory();
    const structures = useContext(MyStructuresContext);
    const structure = useContext(StructureContext);
    const blockedState = useHookstate(globalBlockedState);

    if (structures) {

        if (structures.length === 1) {
            return (
                <h5>{structures[0].name}</h5>
            );
        }

        const onStructureChange = (e) => {
            blockedState.set(true);
            parentProps.toggleStructure(e.value);
            localStorage.setItem("structureId", JSON.stringify(e.value.id));
            if (history.location.pathname !== "/") {
                history.push("/");
            }
        }

        return (
            <h5> <Dropdown value={structure} options={structures} onChange={onStructureChange} optionLabel="name" style={{ width: "100%" }} /></h5>
        );
    }
    return (
        <h5>????</h5>
    );
}